import get from "lodash/get";
import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO
} from "@/config/constants/step-constants";
import ERRORES_DESCRIPTION from "@/config/constants/errores";

/**
 * Opciones disponibles para mockear en el step1
 */
let _mockOptions = {
  APROBADO: "Aprobado"
};
_mockOptions[ERROR_TECNICO] = ERRORES_DESCRIPTION[ERROR_TECNICO].title;
_mockOptions[INDIVIDUO_NEGATIVO] =
  ERRORES_DESCRIPTION[INDIVIDUO_NEGATIVO].title;
_mockOptions[RECHAZADO_OTROS] = ERRORES_DESCRIPTION[RECHAZADO_OTROS].title;

export const mockOptions = _mockOptions;

/**
 * Respuestas de acuerdo al mock elegido
 */
let _mockResponses = {
  APROBADO: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "APROBADO",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  [ERROR_TECNICO]: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "ERROR_TECNICO",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  [INDIVIDUO_NEGATIVO]: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "INDIVIDUO_NEGATIVO",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  [RECHAZADO_OTROS]: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "RECHAZADO_OTROS",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  [ERROR_NOSIS]: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "ERROR_NOSIS",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  [RECHAZADO]: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "RECHAZADO",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  RECHAZADO_NOSIS_CALIFICACION_ACTIVA: {
    data: {
      status: "OK",
      respuesta: {
        respuesta: "RECHAZADO_NOSIS_CALIFICACION_ACTIVA",
        razonSocialResuelta: null,
        randomKey: "ABC123==",
        mensaje: null,
        carro: "XYZ678=="
      },
      errorCode: null
    }
  },
  OFERTA: {
    data: {
      status: "OK",
      respuesta: {
        oferta: {
          montoMaximo: "10000000",
          montoLargoPlazo: "1000000",
          estado: "APROBADO",
          esCliente: true
        },
        randomKey: "ABC123=="
      },
      errorCode: null
    }
  },
  EXCEDIDO: {
    data: {
      status: "OK",
      respuesta: {
        oferta: {
          montoMaximo: "",
          montoLargoPlazo: "",
          estado: "EXCEDIDO",
          esCliente: true
        },
        randomKey: "ABC123=="
      },
      errorCode: null
    }
  },
  OFERTA_RECHAZADA: {
    data: {
      status: "OK",
      respuesta: {
        oferta: {
          montoMaximo: "",
          montoLargoPlazo: "",
          estado: "RECHAZADO",
          esCliente: true
        },
        randomKey: "ABC123=="
      },
      errorCode: null
    }
  },
  CONFIRMAR: {
    data: {
      status: "OK",
      errorCode: null
    }
  }
};

/**
 * Función para derminar respuesta
 * Debe devolver una promesa
 */
export const respuestaMockeada = (endpoint, consulta, mock) => {
  let respuesta = _mockResponses[mock];

  if (endpoint.includes("obtenerOferta")) {
    // Se está intentando obtener oferta
    respuesta = _mockResponses.OFERTA;

    if (parseInt(get(consulta, "facturacionUltimoBalance", "0")) > 150000000) {
      // Excedido
      respuesta = _mockResponses.EXCEDIDO;
    }

    if (parseInt(get(consulta, "facturacionUltimoBalance", "0")) < 1000000) {
      // Excedido
      respuesta = _mockResponses.OFERTA_RECHAZADA;
    }
  }

  if (endpoint.includes("confirmar")) {
    // Se está intentando confirmar oferta
    respuesta = _mockResponses.CONFIRMAR;
  }

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(respuesta);
    }, 500);
  });
};
